/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { AaiOperationTraitDefinition } from '../../asyncapi/models/AaiOperationTraitDefinition';
import { Aai20Components } from '../../asyncapi/v2/models/Aai20Components';
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { Aai20NodeFactory } from '../../asyncapi/v2/models/Aai20NodeFactory';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { AaiComponents } from '../../asyncapi/models/AaiComponents';

/**
 * A command used to create a new operation trait definition item in an AsyncAPI document.
 * @author laurent.broudoux@gmail.com
 * @param {string} newName
 * @param {string} newDescription
 * @class
 * @extends AbstractCommand
 */
export class NewOperationTraitDefinitionCommand extends AbstractCommand {
    public _newName : string;

    public _newDescription : string;

    public _nullComponents : boolean;

    public _defExisted : boolean;

    public constructor(newName? : any, newDescription? : any) {
        if(((typeof newName === 'string') || newName === null) && ((typeof newDescription === 'string') || newDescription === null)) {
            let __args = arguments;
            super();
            if(this._newName===undefined) this._newName = null;
            if(this._newDescription===undefined) this._newDescription = null;
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._defExisted===undefined) this._defExisted = false;
            if(this._newName===undefined) this._newName = null;
            if(this._newDescription===undefined) this._newDescription = null;
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._defExisted===undefined) this._defExisted = false;
            (() => {
                this._newName = newName;
                this._newDescription = newDescription;
            })();
        } else if(newName === undefined && newDescription === undefined) {
            let __args = arguments;
            super();
            if(this._newName===undefined) this._newName = null;
            if(this._newDescription===undefined) this._newDescription = null;
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._defExisted===undefined) this._defExisted = false;
            if(this._newName===undefined) this._newName = null;
            if(this._newDescription===undefined) this._newDescription = null;
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._defExisted===undefined) this._defExisted = false;
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewOperationTraitDefinitionCommand] Executing.");
        let doc20 : Aai20Document = <Aai20Document>document;
        if(this.isNullOrUndefined(doc20.components)) {
            doc20.components = doc20.createComponents();
            this._nullComponents = true;
        }
        this._nullComponents = false;
        let components : Aai20Components = <Aai20Components>doc20.components;
        if(this.isNullOrUndefined(components.getOperationTraitDefinition(this._newName))) {
            let factory : Aai20NodeFactory = new Aai20NodeFactory();
            let traitDef : AaiOperationTraitDefinition = factory.createOperationTraitDefinition(components, this._newName);
            if(!this.isNullOrUndefined(this._newDescription != null)) {
                traitDef.description = this._newDescription;
            }
            components.addOperationTraitDefinition(this._newName, traitDef);
            this._defExisted = false;
        } else {
            this._defExisted = true;
        }
    }

    /**
     * 
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewOperationTraitDefinitionCommand] Reverting.");
        let doc20 : Aai20Document = <Aai20Document>document;
        if(this._nullComponents) {
            doc20.components = null;
        }
        if(this._defExisted) {
            return;
        }
        doc20.components.removeOperationTraitDefinition(this._newName);
    }
}
NewOperationTraitDefinitionCommand["__class"] = "io.apicurio.datamodels.cmd.commands.NewOperationTraitDefinitionCommand";
NewOperationTraitDefinitionCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




